import clsx from 'clsx';
import { ErrorMessage, Field, FieldInputProps, FormikProps } from 'formik';
import { useRef, useState } from 'react';

type Props = {
  label: string;
  name: string;
  autocomplete: string;
  hidden?: boolean;
  maxlength?: number;
  type?: string;
  onkeydown?: any;
};

const InputTextField = (props: Props) => {
  const { label, name, hidden, maxlength, type, autocomplete, onkeydown } =
    props;
  const inputRef = useRef<HTMLInputElement>(null);
  const [hasFocus, setHasFocus] = useState<boolean>(false);

  return (
    <Field type="text" name={name} label={label}>
      {({
        field,
        form,
      }: {
        field: FieldInputProps<any>;
        form: FormikProps<any>;
      }) => {
        return (
          <div className={`${field.name}`} hidden={hidden}>
            <div className="relative">
              <input
                type={type}
                autoComplete={autocomplete}
                onChange={field.onChange}
                onBlur={field.onBlur}
                onKeyDown={onkeydown}
                value={field.value}
                min={0}
                maxLength={maxlength}
                name={name}
                className={`rounded-md border  ${
                  form.errors[name] && form.touched[name]
                    ? 'border-pink_drink'
                    : 'border-gray-400  text-black'
                } px-4 py-2.5 text-sm w-full focus:outline-none`}
                placeholder={''}
                ref={inputRef}
                onFocus={() => {
                  setHasFocus(true);
                }}
                aria-label={label}
              />
              <label
                htmlFor={name}
                onClick={() => inputRef.current?.focus()}
                className={clsx(
                  'mx-3 px-1 transition-all absolute duration-300 top-[14px] text-xs  z-1 left-0 text-gray-ada bg-white cursor-pointer',
                  {
                    '!text-pink_drink': false,
                    '!-top-[10px]': hasFocus || inputRef.current?.value,
                  }
                )}
              >
                {label}
              </label>
            </div>
            <ErrorMessage
              name={field.name}
              component="p"
              className={`text-pink_drink text-xs mt-1 text-left px-4`}
            />
          </div>
        );
      }}
    </Field>
  );
};

export default InputTextField;
